import styled from 'styled-components'
import { Container } from '../../../atoms/GridSystem'

export const AlgoliaSearchBoxIcon = styled.div``

export const AlgoliaSearchBoxReset = styled.div``

export const AlgoliaSearchBox = styled(Container)`
  margin-bottom: ${({ theme }) => theme.rem(40)};
  
  form {
    position: relative;
  }

  input[type="search"] {
    width: 100%;
    padding: ${({ theme }) => theme.rem(20, 72, 20, 56)};
    font-size: ${({ theme }) => theme.rem(18)};
    color: black;
    border: 1px solid black;
    border-radius: ${({ theme }) => theme.rem(80)};
    transition: border-color 0.3s ease-in-out;

    &::-ms-clear {
      display: none;
      width: 0;
      height: 0;
    }
    &::-ms-reveal {
      display: none;
      width: 0;
      height: 0;
    }
    &::-webkit-search-decoration,
    &::-webkit-search-cancel-button,
    &::-webkit-search-results-button,
    &::-webkit-search-results-decoration {
      display: none;
    }

    ${({ theme }) => theme.mediaQuery.lg(`
      font-size: ${theme.rem(16)};
      padding: ${theme.rem(16, 64, 16, 42)};
    `, true)}

    &:focus {
      border-color: black;
    }
  }

  ${AlgoliaSearchBoxIcon},
  ${AlgoliaSearchBoxReset} {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  ${AlgoliaSearchBoxIcon} {
    left: 24px;

    ${({ theme }) => theme.mediaQuery.lg(`
      left: 16px;
    `, true)}
  }

  ${AlgoliaSearchBoxReset} {
    right: 24px;

    ${({ theme }) => theme.mediaQuery.lg(`
      right: 16px;
    `, true)}
  }
`

